import Phaser from 'phaser';
import { TOWER_UPGRADES } from '../../game/content/upgrades';

const radialTowerRasterAssets = ['tower-tesla', 'tower-nulificator'] as const;

const directionalTowerRasterAssets = [
  ['missile', 'missile-turret-base@2x.png', 'missile-turret-module@2x.png'],
  ['howitzer', 'howitzer-turret-base@2x.png', 'howitzer-turret-module@2x.png'],
  ['gatling', 'gatling-turret-base@2x.png', 'gatling-turret-module@2x.png'],
  ['aa', 'aa-turret-base@2x.png', 'aa-turret-module@2x.png'],
  ['goo', 'goo-turret-base@2x.png', 'goo-turret-module@2x.png'],
  ['chain', 'chain-turret-base@2x.png', 'chain-turret-module@2x.png'],
  ['gauss', 'gauss-turret-base@2x.png', 'gauss-turret-module@2x.png'],
  ['oil', 'oil-turret-base@2x.png', 'oil-turret-module@2x.png'],
] as const;

const enemyRasterAssets = [
  'enemy-ground-tiny', 'enemy-ground-small', 'enemy-ground-medium', 'enemy-ground-big',
  'enemy-air-tiny', 'enemy-air-small', 'enemy-air-medium', 'enemy-air-big',
] as const;

const buildingRasterAssets = [
  'building-silo', 'building-wall-factory', 'building-recycler', 'building-radar', 'building-laboratory',
] as const;

const buildingUpgradeRasterAssets = [
  'upgrade-building-thermonuclear-silo',
  'upgrade-building-armament-depot',
  'upgrade-building-mine-factory',
  'upgrade-building-wire-factory',
  'upgrade-building-chemical-depot',
  'upgrade-building-power-plant',
  'upgrade-building-tactical-atc',
  'upgrade-building-orbital-uplink',
  'upgrade-building-particle-accelerator',
  'upgrade-building-black-site',
] as const;

/** Loads clean-room top-down unit art; original reference pixels and assets are never used. */
export class BootScene extends Phaser.Scene {
  constructor() { super('boot'); }

  preload(): void {
    this.load.image('terrain-sand', 'assets/terrain/pale-sand.png');
    this.load.image('terrain-rock', 'assets/terrain/rust-rock.png');
    radialTowerRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
    directionalTowerRasterAssets.forEach(([name, base, module]) => {
      this.load.image(`tower-${name}-base`, `assets/units/${base}`);
      this.load.image(`tower-${name}-module`, `assets/units/${module}`);
    });
    Object.values(TOWER_UPGRADES).forEach((upgrade) => {
      this.load.image(`tower-upgrade-${upgrade.id.replace('.', '-')}`, upgrade.moduleAsset);
    });
    enemyRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
    buildingRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
    buildingUpgradeRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
    this.load.image('ability-mine', 'assets/units/ability-mine.png');
    this.load.image('ability-barbed-wire', 'assets/units/ability-barbed-wire.png');
  }

  create(): void { this.scene.start('battle'); }
}
